import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Transfer, Radio } from 'antd';

export default class NoteForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      propertyIds: [props.propertyId],
      roomIds: [],
      showSpecificRooms: true,
      currentUnitType: true,
    };
  }

  componentDidMount() {
    const {
      modalType,
      commissionTier: { unitTypes },
    } = this.props;
    if (modalType !== 'addNew') {
      const keys = map(unitTypes, item => item.id);
      this.setState({
        roomIds: keys,
        currentUnitType: isEmpty(unitTypes),
      });
    }
    this.handleDealSpecificRooms();
  }

  handleChangePropertyIds = newPropertyIds => {
    this.setState({ propertyIds: newPropertyIds });
  };

  handleChangeRoomsIds = newRoomIds => {
    this.setState({ roomIds: newRoomIds });
  };

  handleDealSpecificRooms = () => {
    const { commissionRooms } = this.props;
    const isDataEmpty = isEmpty(commissionRooms);
    if (isDataEmpty) {
      this.setState({ showSpecificRooms: false });
    }
  };

  renderTransfer = fields => {
    const {
      t,
      landlordProperties,
      commissionRooms,
      form: { getFieldDecorator },
    } = this.props;
    const { propertyIds, roomIds } = this.state;

    const isApplyProperty = fields === 'landlordProperties';
    const dataSource = isApplyProperty ? landlordProperties : commissionRooms;
    const targetKeys = isApplyProperty ? propertyIds : roomIds;
    const errorMsg = isApplyProperty
      ? 'cms.property.commission_form_modal.error_message.can_not_empty'
      : 'cms.property.commission_form_modal.error_message.at_least_one';
    return (
      <Form.Item>
        {getFieldDecorator(fields, {
          trigger: 'onChange',
          rules: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if ((!value && targetKeys.length > 0) || (value && value.length > 0)) {
                  callback();
                }

                callback(t(errorMsg));
              },
            },
          ],
        })(
          <Transfer
            dataSource={dataSource}
            showSearch
            rowKey={item => item.node.id}
            targetKeys={targetKeys}
            lazy={false}
            onChange={isApplyProperty ? this.handleChangePropertyIds : this.handleChangeRoomsIds}
            render={item => item.node.name.toLowerCase()}
            listStyle={{ width: 'calc(50% - 20px)', height: '236px' }}
          />,
        )}
      </Form.Item>
    );
  };

  render() {
    const {
      t,
      form: { getFieldDecorator, getFieldValue },
      modalType,
    } = this.props;
    const { showSpecificRooms, currentUnitType } = this.state;
    const isEdit = modalType === 'edit';

    return (
      <div>
        <h3 className="commission-from__form-title">
          <div className="commission-from__title-block" />
          <Choose>
            <When condition={isEdit}>
              {t('cms.property.commission_form_modal.application_to_rooms')}
            </When>
            <Otherwise>
              {t('cms.property.commission_form_modal.application_to_properties')}
            </Otherwise>
          </Choose>
        </h3>
        <If condition={!isEdit}>
          <div className="commission-from__apply-type-wrap">
            <Form.Item>
              {getFieldDecorator('applyType', {
                trigger: 'onChange',
                initialValue: 'currentProperty',
              })(
                <Radio.Group>
                  <Radio value="currentProperty">
                    {t('cms.property.commission_form_modal.apply_to_current_property.label')}
                  </Radio>
                  <Radio value="moreProperties">
                    {t('cms.property.commission_form_modal.apply_to_more_properties.label')}
                  </Radio>
                </Radio.Group>,
              )}
            </Form.Item>
          </div>
        </If>
        <If condition={getFieldValue('applyType') === 'currentProperty' || isEdit}>
          <div className="commission-from__transfer-wrap">
            <Form.Item>
              {getFieldDecorator('applyRooms', {
                trigger: 'onChange',
                initialValue: currentUnitType ? 'allRooms' : 'specificRooms',
              })(
                <Radio.Group>
                  <Radio value="allRooms">
                    {t('cms.property.commission_form_modal.apply_to_all_rooms.label')}
                  </Radio>
                  <If condition={showSpecificRooms}>
                    <Radio value="specificRooms">
                      {t('cms.property.commission_form_modal.apply_to_specific_rooms.label')}
                    </Radio>
                  </If>
                </Radio.Group>,
              )}
            </Form.Item>
            <If condition={getFieldValue('applyRooms') === 'specificRooms'}>
              <div className="commission-from__transfer-title-wrap commission-from__transfer-title-wrap--space">
                <span className="commission-from__transfer-title-item">
                  {t('cms.properties.edit.rooms.label.room_name')}
                </span>
                <span className="commission-from__transfer-title-item">
                  {t('cms.property.commission_form_modal.apply_to.title')}
                </span>
              </div>
              {this.renderTransfer('unitTypeIds')}
            </If>
          </div>
        </If>
        <If condition={getFieldValue('applyType') === 'moreProperties'}>
          <div className="commission-from__transfer-wrap">
            <div className="commission-from__transfer-title-wrap">
              <span className="commission-from__transfer-title-item">
                {t('cms.property.commission_form_modal.property_name.title')}
              </span>
              <span className="commission-from__transfer-title-item">
                {t('cms.property.commission_form_modal.apply_to.title')}
              </span>
            </div>
            {this.renderTransfer('landlordProperties')}
          </div>
        </If>
      </div>
    );
  }
}

NoteForm.propTypes = {
  t: PropTypes.func.isRequired,
  form: PropTypes.object,
  landlordProperties: PropTypes.array,
  propertyId: PropTypes.string,
  commissionTier: PropTypes.object,
  commissionRooms: PropTypes.array,
  modalType: PropTypes.string,
};
NoteForm.defaultProps = {
  t: () => {},
  form: {},
  landlordProperties: [],
  propertyId: '',
  commissionTier: {},
  commissionRooms: [],
  modalType: '',
};
